export const GET_PRODUCTS_START = 'GET_PRODUCTS_START';
export const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS';
export const GET_PRODUCTS_FAIL = 'GET_PRODUCTS_FAIL';
export const GET_SIMILAR_PRODUCTS = 'GET_SIMILAR_PRODUCTS';
export const SET_CATEGORY = 'SET_CATEGORY';
export const REMOVE_CATEGORY = 'REMOVE_CATEGORY';
export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';
